import MRPLanding from '@/views/landing/CommonLanding';

export default [{
    path: '/mrp/landing',
    name: 'mrplanding',
    component: MRPLanding,
    meta: { layout: 'landing', accessedby: 'MRP' }
}];